import { useDispatch } from 'react-redux'
import BlogFooter from '../../../components/blog/Footer'
import { gotoLogIn } from '../../../redux/actions/AuthActions'

import { AppContainer, Body, Button, ButtonLink, Container, Content, H2, Image, MobileHeading, Show, Text } from '../landing.styles.js'

import Brands from '../Brands'
import FooterBanner from '../FooterBanner'
import Header from '../Header'
import Join from '../Join'
import Reviews from '../Reviews'

import headerBg from './header-bg.png'
import img1 from './img1.png'
import img2 from './img2.png'
import img3 from './img3.png'
import img5 from './img5.png'

const Kitchen = () => {
  const dispatch = useDispatch()

  const openLogin = () => {
    dispatch(gotoLogIn())
  }
  return (
    <div>
      <Header
        title="Garage Design App to Plan Layouts, Organize Storage, and Build Your Space"
        subtitle="Visualize your garage layout, organize tools and equipment, and create your ideal setup with our easy-to-use garage design and layout planner app."
        bg={headerBg}
        meta={{
          title: 'Garage Design App | Plan Layouts & Design Your Garage Virtually',
          description:
            'Design your garage with confidence using the DecorMatters garage design app. Plan layouts, organize storage, and visualize your garage space virtually. Try garage styles, add tools and appliances, and customize your layout before making changes.'
        }}
        alt="Dining room design app for planning layouts, arranging furniture, and visualizing decor"
      />
      <Join
        title="Join 10 Million+ Users Designing Smarter Garages with"
        description="Transform your garage into a functional and organized space with the DecorMatters garage design app. Whether you need better storage, a home workshop, or a complete garage makeover, our app helps you plan layouts, test designs, and visualize the result — all from your phone. Design a garage that fits your tools, vehicles, and lifestyle using our virtual planner, and get inspired by a creative community of over 10 million home design enthusiasts."
      />
      <Body>
        <Container>
          <Content>
            <Show on="desktop">
              <H2>Design a Garage That Works for Storage, Hobbies, and Everyday Life</H2>
            </Show>
            <Text>
              Your garage can be more than a place to park. With the DecorMatters garage design app, you can visualize storage solutions, create functional workspaces, or even turn your garage into an extension of your home. Whether you're storing
              tools, organizing sports gear, setting up a workshop, or adding a second fridge, our room layout planner helps you customize and optimize your space with confidence.
            </Text>
            <Button onClick={openLogin}>Start Designing Now</Button>
          </Content>
          <MobileHeading>
            <Show on="mobile">
              <H2>Design a Garage That Works for Storage, Hobbies, and Everyday Life</H2>
            </Show>
            <Image src={img1} alt="Virtual garage layout featuring tool racks, car space, appliances, and a DIY workspace using a garage layout planner" />
          </MobileHeading>
        </Container>
        <Container>
          <Content>
            <Show on="desktop">
              <H2>Design Your Garage with the App Trusted for Every Room in the House</H2>
            </Show>
            <Text>
              Can't hire a professional? No problem. The DecorMatters garage design app puts expert-level tools in your hands. Trusted by millions and featured in top publications like House & Garden and Realtor.com, our app makes it easy to design
              your garage layout, choose decor, and plan functional spaces, just like you would for your kitchen, bathroom, or bedroom. It's everything you need to design your garage from your phone.
            </Text>
            <Button onClick={openLogin}>Start Designing Now</Button>
          </Content>
          <MobileHeading>
            <Show on="mobile">
              <H2>Design Your Garage with the App Trusted for Every Room in the House</H2>
            </Show>
            <Image src={img2} alt="DecorMatters app interface showing garage, kitchen, and bathroom designs with top-rated home design features" />
          </MobileHeading>
        </Container>
        <Container>
          <Content>
            <Show on="desktop">
              <H2>Unlock Premium Garage Design Tools for Smarter Planning</H2>
            </Show>
            <Text>
              Take your garage design to the next level with DecorMatters Premium. Unlock powerful tools that help you visualize your space, test layouts, and plan with precision. With a premium membership, you can:
              <br />
              <br />
              • Upload real photos of your garage for accurate design
              <br />
              • Use Augmented Reality (AR) to preview furniture, storage, and workspaces
              <br />
              • Save draft layouts and organize decor ideas
              <br />
              • Access exclusive furniture and decor from top retailers
              <br />
              <br />
              Whether you're designing a garage gym, workshop, or storage system, these features help you build with confidence.
            </Text>
            <Button onClick={openLogin}>Start Designing Now</Button>
          </Content>
          <MobileHeading>
            <Show on="mobile">
              <H2>Unlock Premium Garage Design Tools for Smarter Planning</H2>
            </Show>
            <Image src={img3} alt="AR garage planner tools with virtual furniture, wishlist, and saved layouts on the DecorMatters design app" />
          </MobileHeading>
        </Container>
        <AppContainer>
          <Container>
            <Show on="mobile">
              <ButtonLink target="_blank" href="https://apps.apple.com/us/app/decor-matters-design-play/id1168709467">
                Download iOS App
              </ButtonLink>
            </Show>
            <Image src={img5} alt="Download screen of DecorMatters garage design app with virtual layout, storage ideas, and furniture arrangement" />
            <Content>
              <H2>Download the DecorMatters Garage Design App and Start Creating</H2>
              <Text>
                Start planning your dream garage today with the DecorMatters garage design app. Whether you need better storage, a workshop, or a multi-functional space, our app gives you the tools to design with clarity and confidence.
                <br />
                <br />
                Visualize layouts, experiment with garage furniture, and turn ideas into reality — right from your phone. Download the app now and see why over 10 million users trust DecorMatters for smart, simple home design.
              </Text>
              <Show on="desktop">
                <ButtonLink target="_blank" href="https://apps.apple.com/us/app/decor-matters-design-play/id1168709467">
                  Start Designing Now
                </ButtonLink>
              </Show>
            </Content>
          </Container>
        </AppContainer>
      </Body>
      <Brands />
      <Reviews />
      <FooterBanner />
      <BlogFooter />
    </div>
  )
}

export default Kitchen
